/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

import "./InputAdornment.scss";

export interface IInputAdornmentProps {
	className?: string;
	square?: boolean;
	center?: boolean;
	children?: React.ReactNode;
}

const InputAdornment: React.FC<IInputAdornmentProps> = ({ className, children, square, center }) => {
	const baseClass = BEM("edt-input-adornment", null, {
		square,
		center
	});

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};

const InputAdornmentMemo = React.memo(InputAdornment);

export { InputAdornmentMemo as InputAdornment };
